<template>
  <!-- <div no-body class="p-4 flex  w-full overflow-x-auto ">
    <div class="w-3/4">
      <Box1 />
    </div>
    <div class="w-3/4 ml-4">
      <Box2 />
    </div>
    <div class="w-3/4 ml-4">
      <Box3 />
    </div>
    <div class="w-3/4 ml-4">
      <Box4 />
    </div>
    <div class="w-3/4 ml-4">
      <Box5 />
    </div>
  </div> -->
  <!-- <b-card class="rounded-xl"> -->
  <div class="p-6">
    <swiper :options="swiperOption" :key="rtl" class="px-10 w-full">
      <swiper-slide
        class="rounded cursor-pointer rounded-lg shadow-none w-full"
      >
        <Box1 />
      </swiper-slide>

      <swiper-slide
        class="rounded cursor-pointer rounded-lg shadow-none w-full"
      >
        <Box2 />
      </swiper-slide>

      <swiper-slide
        class="rounded cursor-pointer rounded-lg shadow-none w-full"
      >
        <Box3 />
      </swiper-slide>
      <swiper-slide
        class="rounded cursor-pointer rounded-lg shadow-none w-full"
      >
        <Box4 />
      </swiper-slide>
      <swiper-slide
        class="rounded cursor-pointer rounded-lg shadow-none w-full"
      >
        <Box5 />
      </swiper-slide>
      <swiper-slide
        class="rounded cursor-pointer rounded-lg shadow-none w-full"
      >
        <Box6 />
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
  <!-- </b-card> -->
</template>

<script>
import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@/views/admin/scss/Index.scss";
import Box1 from "./components/Box1.vue";
import Box2 from "./components/Box2.vue";
import Box3 from "./components/Box3.vue";
import Box4 from "./components/Box4.vue";
import Box5 from "./components/Box5.vue";
import Box6 from "./components/Box6.vue";
export default {
  data() {
    return {
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 20,
        breakpoints: {
          1600: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  components: {
    Box1,
    Box2,
    Box3,
    Box4,
    Box5,
    Box6,
    swiper,
    swiperSlide,
  },
};
</script>
<style lang="scss">
#item-detail-page {
  .color-radio {
    height: 2.28rem;
    width: 2.28rem;

    > div {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .image-div {
    display: flex;
    flex-flow: row;
  }

  .image > img {
    margin: auto 6px;
    height: 60px;
    width: 60px;
  }

  .item-features {
    background-color: #f7f7f7;
  }

  .product-sales-meta-list {
    .vs-list--icon {
      padding-left: 0;
    }
  }

  .related-product-swiper {
    // padding-right: 2rem;
    // padding-left: 2rem;

    .swiper-wrapper {
      padding-bottom: 2rem;

      > .swiper-slide {
        background-color: #f7f7f7;
        box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.1),
          0 5px 12px 0 rgba(0, 0, 0, 0.08) !important;
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      transform: scale(0.5);
      filter: hue-rotate(40deg);
    }

    .swiper-button-next {
      right: 0;
    }

    .swiper-button-prev {
      left: 0;
    }
  }
}
.h-60vh {
  height: 60vh !important;
}
</style>
